/* eslint-disable @typescript-eslint/ban-ts-comment */
import {
  FormFieldType,
  IFormDate,
  IFormValidatable,
  RequiredValidations,
} from '../typings';
import { BaseFormFieldBuilder } from '.';

type Validations = RequiredValidations<IFormDate['validations']>;

export class DateFormFieldBuilder
  extends BaseFormFieldBuilder<IFormDate>
  implements IFormValidatable<Validations>
{
  // @ts-ignore
  private _type = FormFieldType.Date as const;
  protected declare _value?: IFormDate['value'];
  private _validations?: Validations;

  constructor() {
    super();
  }

  public validation(value: Validations[number]): this {
    if (this._validations) {
      this._validations.push(value);
    } else {
      this._validations = [value];
    }

    return this;
  }

  public validations(value: Validations): this {
    if (this._validations) {
      this._validations.push(...value);
    } else {
      this._validations = [...value];
    }

    return this;
  }
}
